import * as $ from 'jquery';

export function showLoading(component) {
    $("." + component+" .loading-component").css("visibility", "visible");
}

export function hideLoading(component) {
    $("." + component +" .loading-component").css("visibility", "hidden");
}